module.exports = __webpack_public_path__ + "static/img/chanping14.9485323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/chanping14.jpg
// module id = 8iBU
// module chunks = 0